<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!-- tit -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border show-summary :summary-method="getSummaries">
            <el-table-column
                v-for="(col, inx) in tableRows"
                :key="inx"
                :type="col.type"
                :prop="col.prop"
                :label="col.name"
                :render-header="labelHead"
                :min-width="getColumnWidth(col.label, col.prop, tableData)"
                header-align="center"
                align="center"
            >
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
          </el-table>
        </div>

        <el-dialog
            :title='addFinancialSummaryAccountForm.id == null ? "新增财务汇总" : (showFinancialSummaryAccountDialogVisible ? "查看财务汇总" : "修改财务汇总")'
            :visible.sync="addFinancialSummaryAccountDialogVisible"
            :close-on-click-modal="false"
            width="700px"
            @close="handleCloseFinancialSummaryAccount"
            class="custom-form-dialog"
        >
          <el-form
              size="mini"
              :model="addFinancialSummaryAccountForm"
              ref="addFinancialSummaryAccountForm"
              :rules="addFinancialSummaryAccountFormRules"
              label-width="110px"
              label-position="right"
              :disabled="showFinancialSummaryAccountDialogVisible"
          >
            <!-- 第一行：编码 + 合约单位 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="编码：" prop="code">
                  <el-input
                      v-model="addFinancialSummaryAccountForm.code"
                      clearable
                      @input="checkCodeExist"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="适用对象:" prop="applyobject">
                  <el-select
                      v-model="addFinancialSummaryAccountForm.applyobject"
                      placeholder="请选择"
                      style="width: 100%"
                      clearable
                  >
                    <el-option
                        v-for="item in applyobjectOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第二行：名称 + 状态 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="名称：" prop="name">
                  <el-input
                      v-model="addFinancialSummaryAccountForm.name"
                      @input="handleExpenseCateGoryForGetPy"
                      placeholder="请输入完整名称"
                      clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态：" prop="status">
                  <el-select
                      v-model="addFinancialSummaryAccountForm.status"
                      placeholder="请选择状态"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="item in stateOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="费用类别:" prop="cosIds">
                  <el-select
                      v-model="addFinancialSummaryAccountForm.cosIds"
                      clearable
                      filterable
                      multiple
                      remote
                      reserve-keyword
                      :remote-method="getExpenseCategoryList"
                      @remove-tag="handleRemoveTage"
                      @change="handleRemoveChange"
                      placeholder="请选择费用类别"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="item in expenseCategoryOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 拼音简码（单独一行） -->
            <el-form-item label="拼音简码：">
              <el-input
                  v-model="addFinancialSummaryAccountForm.pycode"
                  placeholder="自动生成"
                  disabled
                  class="disabled-input"
              />
            </el-form-item>


            <!-- 备注（文本域） -->
            <el-form-item label="备注：">
              <el-input
                  type="textarea"
                  v-model="addFinancialSummaryAccountForm.remarks"
                  :rows="3"
                  placeholder="可输入额外说明信息"
                  resize="none"
                  show-word-limit
                  maxlength="200"
              />
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button :disabled="showFinancialSummaryAccountDialogVisible" size="mini" type="primary"
                       @click="handleAddFinancialSummaryAccount">保存
            </el-button>
            <el-button :disabled="showFinancialSummaryAccountDialogVisible" size="mini"
                       @click="handleCloseFinancialSummaryAccount">取消
            </el-button>
          </div>
        </el-dialog>

      </div>
    </div>

    <el-pagination
        class="fixed-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    >
    </el-pagination>
  </div>
</template>

<script>
import { pinyin } from "pinyin-pro";
import dayjs from "dayjs";
import { withLoading } from "@/untils/loading";
import { getExpenseCategoryList } from "@/api/managementMenu/expenseCategory";

import { getShiftEndStatisticsPage } from "@/api/shiftEndStatistics/shiftEndStatistics";
import {getFinancialSummaryAccountList} from "@/api/financialSummaryManagement/financialSummaryAccount";

// 工厂函数：生成空的财务汇总表单
const getEmptyFinancialSummaryForm = () => ({
  id: null,
  code: '',
  cosIds: [],
  name: '',
  applyobject: null,
  pycode: '',
  remarks: '',
  status: 1,
});

export default {
  data() {
    return {
      // 基础数据
      CatalogueName: '结班列表',
      iconComes: 'el-icon-byj',
      loading: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,

      // 模态框控制
      addFinancialSummaryAccountDialogVisible: false,
      showFinancialSummaryAccountDialogVisible: false,

      // 表单数据
      addFinancialSummaryAccountForm: getEmptyFinancialSummaryForm(),
      addFinancialSummaryAccountFormRules: {
        applyobject: [{ required: true, message: ' ', trigger: 'change' }],
        status: [{ required: true, message: ' ', trigger: 'change' }],
        name: [
          { required: true, message: ' ', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur' }
        ],
        code: [{ required: true, message: ' ', trigger: 'blur' }],
      },

      // 静态选项
      applyobjectOptions: [{ id: 0, label: '全部' }, { id: 1, label: '门诊' }, { id: 2, label: '住院' }],
      stateOption: [{ id: 0, label: '禁用' }, { id: 1, label: '可用' }],

      // 映射用的选项数组（配合 tableRows 的 op 字段）
      doctorOptions: [],
      deptOptions: [],

      // 表格数据
      tableData: [],

      // 表格列配置：需要映射的列加 op 字段
      tableRows: [
        { name: "系统序号", prop: "id" },
        { name: "诊所", prop: "clinicId", op: 'deptOptions' },
        { name: "开始时间", prop: "startTime" },
        { name: "结算时间", prop: "endTime" },
        { name: "结算总金额", prop: "amount" },
        { name: "创建人", prop: "createId", op: 'doctorOptions' },
        { name: "创建时间", prop: "createTime" },
        { name: "备注", prop: "remarks" },
      ],

      // 按钮配置
      headerBtn: [
        { search: "search", title: "搜索", type: "success", style: { marginLeft: "-20px" } },
        { add: "add", title: "新增", type: "warning" },
      ],

      // 财务汇总相关数据
      expenseCategoryOptions: [],
      financialOptions: [],
      codeExist: false,
      nameExist: false,
    };
  },

  mounted() {
    // 加载 store 中的医生/科室选项
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'] || [];

    this.loadData();
    this.getFinancial();
  },

  methods: {
    /**
     * 通用单元格映射（参照 ChargingPrice.vue 的模式）
     * - 列配置里有 col.op → 走 this[col.op] 数组按 id 查找 label
     * - 用 `==` 宽松比较，天然兼容 '3' == 3 这种字符串/数字差异
     * - 找不到时回落显示原值
     * - amount 单独走千分位
     */
    safeGetMappedValue(col, row) {
      const raw = row[col.prop];
      if (raw === null || raw === undefined) return '';

      // 金额格式化
      if (col.prop === 'amount') {
        return this.formatAmount(raw);
      }

      // 无映射配置，直接显示原值
      if (!col.op || !Array.isArray(this[col.op])) return raw;

      // 宽松相等匹配（'3' == 3 为 true）
      const match = this[col.op].find(item => item.id == raw);
      return match?.label ?? raw;
    },

    // 金额格式化：两位小数 + 千分位
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '';
      const num = Number(val);
      if (isNaN(num)) return val;
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    // 时间格式化
    formatDateTime(val) {
      if (!val) return '';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },

    // 表格合计行计算
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const numericProps = ['amount'];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (numericProps.includes(column.property)) {
          const total = data.reduce((sum, item) => sum + (Number(item[column.property]) || 0), 0);
          sums[index] = this.formatAmount(total);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    // 编码重复校验
    checkCodeExist() {
      if (!this.addFinancialSummaryAccountForm.code) return true;
      this.codeExist = this.financialOptions.some(
          item => item.code === this.addFinancialSummaryAccountForm.code
      );
      if (this.codeExist) {
        this.$message.error('该编码已被使用，请重新输入');
        return false;
      }
      return true;
    },

    // 名称重复校验 + 拼音生成
    handleExpenseCateGoryForGetPy() {
      if (!this.addFinancialSummaryAccountForm.name) return false;
      this.nameExist = this.financialOptions.some(
          item => item.label === this.addFinancialSummaryAccountForm.name
      );
      if (this.nameExist) {
        this.$message.error('该名称已被使用，请重新输入');
        this.addFinancialSummaryAccountForm.pycode = '';
        return false;
      }
      this.addFinancialSummaryAccountForm.pycode = pinyin(this.addFinancialSummaryAccountForm.name, {
        pattern: 'first',
        toneType: 'none',
        separator: ''
      }).toLocaleUpperCase();
      return true;
    },

    // 加载财务汇总列表（用于校验）
    async getFinancial() {
      const res = await getFinancialSummaryAccountList();
      this.financialOptions = res.data.map(item => ({
        id: item.id,
        label: item.name,
        code: item.code
      }));
    },

    // 费用类别远程搜索
    async getExpenseCategoryList(query) {
      const res = await getExpenseCategoryList({ name: query });
      if (res.code === 200) {
        this.expenseCategoryOptions = res.data.map(item => ({
          id: item.id,
          applyobject: item.applyobject,
          label: item.name
        }));
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员");
      }
    },

    handleRemoveChange(item) {
      if (item.length <= 0) return;
      this.expenseCategoryOptions.push(item[item.length - 1]);
    },
    handleRemoveTage(tag) {
      this.expenseCategoryOptions = this.expenseCategoryOptions.filter(item => item.id !== tag);
    },

    // 编辑财务汇总
    async handleEditExpenseCateGory(row) {
      const res = await getOneFinancialSummaryAccountById(row.id);
      if (res.code === 200) {
        this.addFinancialSummaryAccountForm = { ...res.data };
        this.addFinancialSummaryAccountForm.cosIds = res.data.costtypeList.map(item => item.id);
        this.expenseCategoryOptions = res.data.costtypeList.map(item => ({
          id: item.id,
          applyobject: item.applyobject,
          label: item.name
        }));
        this.addFinancialSummaryAccountDialogVisible = true;
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员");
      }
    },

    // 保存财务汇总（新增/编辑）
    async handleAddFinancialSummaryAccount() {
      if (!this.checkCodeExist()) return;
      if (!this.handleExpenseCateGoryForGetPy()) return;
      try {
        await this.$refs.addFinancialSummaryAccountForm.validate();
      } catch {
        this.$message.warning("请完善表单信息");
        return;
      }
      await withLoading(this, '数据提交中...')(async () => {
        let res;
        if (!this.addFinancialSummaryAccountForm.id) {
          res = await addFinancialSummaryAccount(this.addFinancialSummaryAccountForm);
        } else {
          res = await editFinancialSummaryAccount(this.addFinancialSummaryAccountForm);
        }
        if (res.code === 200) {
          this.handleCloseFinancialSummaryAccount();
          await this.loadData();
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },

    // 关闭财务汇总对话框
    handleCloseFinancialSummaryAccount() {
      this.addFinancialSummaryAccountForm = getEmptyFinancialSummaryForm();
      this.$nextTick(() => {
        this.$refs.addFinancialSummaryAccountForm?.clearValidate();
      });
      this.addFinancialSummaryAccountDialogVisible = false;
      this.showFinancialSummaryAccountDialogVisible = false;
    },

    // 双击查看详情
    async handleDbShowData(row) {
      const res = await getOneFinancialSummaryAccountById(row.id);
      if (res.code === 200) {
        this.addFinancialSummaryAccountForm = { ...res.data };
        this.addFinancialSummaryAccountForm.cosIds = res.data.costtypeList.map(item => item.id);
        this.expenseCategoryOptions = res.data.costtypeList.map(item => ({
          id: item.id,
          applyobject: item.applyobject,
          label: item.name
        }));
        this.addFinancialSummaryAccountDialogVisible = true;
        this.showFinancialSummaryAccountDialogVisible = true;
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员");
      }
    },

    // 加载结班列表数据
    async loadData() {
      try {
        const res = await getShiftEndStatisticsPage({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = (res.data.content || []).map(item => ({
            ...item,
            startTime: this.formatDateTime(item.startTime),
            endTime: this.formatDateTime(item.endTime),
            createTime: this.formatDateTime(item.createTime),
          }));
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },

    // 顶部按钮点击
    async handClick(i) {
      if (i === 0) {
        await this.loadData();
      } else if (i === 1) {
        this.addFinancialSummaryAccountDialogVisible = true;
      }
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 列宽辅助（保留原方法）
    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 80;
      const padding = 30;
      const texts = [...tableData.map(item => item?.[prop] ?? ''), label];
      const maxWidth = Math.max(...texts.map(t => this.getTextWidth(String(t)) + padding));
      return Math.max(minWidth, maxWidth);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>

<style lang="less" scoped>
/* 样式保持原样，未做任何修改 */
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.patient-dialog {
  .el-dialog {
    max-height: 70vh !important;
    height: auto !important;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 15% !important;
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;

    .el-dialog__header {
      height: 35px !important;
      padding: 5px 15px !important;
      flex-shrink: 0;

      .el-dialog__title {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .el-dialog__body {
      flex: 1;
      padding: 8px !important;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 0;

      .aform, .bform {
        flex: 1;
        overflow-y: auto;
        margin-bottom: 5px;
        min-height: 0;

        .el-tabs {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0;

          .el-tabs__content {
            flex: 1;
            overflow: visible;
            padding: 5px;
          }
        }
      }
    }

    .el-dialog__footer {
      height: 40px !important;
      padding: 5px !important;
      flex-shrink: 0;

      .el-button {
        padding: 7px 15px !important;
      }
    }
  }

  @media (max-height: 600px) {
    .el-dialog {
      max-height: 80vh !important;
      top: 10% !important;

      .el-dialog__body {
        padding: 5px !important;
      }
    }
  }
}

/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/deep/ .el-tabs__item {
  padding: 0 10px !important;
  height: 30px !important;
  line-height: 30px !important;
}

/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-icon-arrow-left:before {
  content: "\e67d";
  font-size: 18px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-descriptions {
  font-size: 12px !important;
}

/deep/ .el-descriptions-item__container {
  display: flex !important;
  padding-top: 12px !important;
}

/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 0;
  display: flex;
  justify-content: right;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

/deep/ .el-pagination {
  padding: 6px;
}

.MedicenCata {
  height: 100%;
  width: 100%;
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;
    .header-icon {
      display: flex;
      align-items: center;
    }
  }

  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto;
    .main-left {
      .custom-tree {
        max-height: 100%;
        overflow-y: auto;
      }

      /deep/ .el-tree-node__content {
        height: 40px;
        padding-left: 0 !important;
      }

      /deep/ .el-tree-node__label {
        font-size: 12px;
      }

      width: 10%;
      height: 100%;
    }

    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }
      }

      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {
      }
    }
  }

  .feet {
    .addmessagesBox {
      .aform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }

      .bform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }
    }

    .messagesBox {
      .tabs {
        /deep/ .el-form-item__content {
          display: flex;

          span {
            font-size: 12px;
          }
        }

        .oneLine {
          width: 524px;
        }
      }

      /deep/ .el-dialog__title {
        font-size: 12px;
      }

      /deep/ .el-table {
        font-size: 12px;
      }
    }
  }
}
</style>